<script setup lang="ts">
/**
 * UI-kit component
 * Category: Links
 * Name: LinkTextPrimaryMedium
 */
import type { LinkTextPrimaryMediumProps } from '../types/interfaces'

import { IconContainer } from '@shared/ui/other'

import { useLinkTextPrimaryMedium } from '../composables/link-text-primary-medium.hook'

import { NuxtLink } from '#components'

defineOptions({
  name: 'LinkTextPrimaryMedium',
})

const props = withDefaults(defineProps<LinkTextPrimaryMediumProps>(), {
  color: 'blue',
  target: '_self',
  disabled: false,
})

const {
  refIsBlankTarget,
} = useLinkTextPrimaryMedium({ props })
</script>

<template>
  <component
    :is="refIsBlankTarget ? 'a' : NuxtLink"
    :href="refIsBlankTarget ? href : undefined"
    :to="refIsBlankTarget ? null : href"
    :class="['link-text-primary-medium', color, { disabled }]"
    :target="target"
  >
    <IconContainer v-if="$slots.iconLeft">
      <slot name="iconLeft" />
    </IconContainer>
    <slot />
    <IconContainer v-if="$slots.iconRight">
      <slot name="iconRight" />
    </IconContainer>
  </component>
</template>

<style lang="scss" scoped src="../styles/_link-text-primary-medium.scss" />
